module.exports = __webpack_public_path__ + "img/35.214864c9.jpg";